import { WarningOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import Button from 'app/components/UI-Elements/General/Button'
import { useQuery } from 'app/lib/hooks/useQuery'
import useTranslation from 'app/lib/hooks/useTranslation'
import { INCIDENT_REPORTING_ENABLED_QUERY } from 'app/queries/Incidents'
import testIds from 'test_ids.json'

import { useCurrentIncidentSubject } from './CurrentSubject'
import { IncidentSubject } from './typing'
import { useReportIncident } from './useReportIncident'

type Props = Omit<React.ComponentProps<typeof Button>, 'onClick' | 'title'> & {
  subject?: IncidentSubject
  iconOnly?: boolean
}

const ReportButton: React.FC<Props> = ({ subject, iconOnly, ...buttonProps }) => {
  const { t } = useTranslation()
  const reportIncident = useReportIncident()
  const currentSubject = useCurrentIncidentSubject()
  const { data } = useQuery<{ incidentReportingEnabled: boolean }>(INCIDENT_REPORTING_ENABLED_QUERY)
  const label = t({ id: 'record.incident.report.button' })

  if (!data?.incidentReportingEnabled) return null

  const button = (
    <Button
      icon={<WarningOutlined />}
      shape={iconOnly ? 'circle' : undefined}
      type={iconOnly ? 'text' : 'default'}
      aria-label={label}
      data-testid={testIds.modules.incident.report_button}
      {...buttonProps}
      onClick={() => reportIncident(subject ?? currentSubject)}>
      {!iconOnly && label}
    </Button>
  )

  return iconOnly ? <Tooltip title={label}>{button}</Tooltip> : button
}

export default ReportButton
